import { castArray, isEmpty } from 'lodash';
import { Autocomplete, TextField } from '@mui/material';
import { Role } from 'lib/types';
import { InputAdornmentCheck } from 'elements/InputAdornmentCheck';
import { createFilterOptions } from '@mui/material/Autocomplete';
import { useUserRoles } from 'lib/contexts/userRolesContext';
import { RoleSelectValue } from 'components/RoleSelect';

export interface Props {
  onChange: (value: RoleSelectValue) => void;
  multiple?: boolean;
  value: RoleSelectValue;
  label?: string;
  size?: 'small' | 'medium';
  limitTags?: number;
}

// Include aliases in the string that we're matching.
const filterOptions = createFilterOptions({
  stringify: (option: Role) => `${option.name} ${castArray(option.aliases).join(' ')}`,
});

export const UserRoleSelect = ({
  label, onChange, value, multiple, size, limitTags,
}: Props) => {
  const userRoles = useUserRoles();

  return (
    <Autocomplete
      multiple={multiple}
      options={userRoles || []}
      onChange={(_, v) => onChange(v)}
      value={value}
      getOptionLabel={(option) => option?.name || ''}
      filterOptions={filterOptions}
      isOptionEqualToValue={(option, v) => option?.id === v?.id}
      limitTags={limitTags}
      renderInput={(params) => {
        const newInputProps = !multiple && !isEmpty(value) ? {
          ...params.InputProps,
          startAdornment: <InputAdornmentCheck />,
        } : { ...params.InputProps };
        return (
          <TextField
            {...params}
            label={label || (multiple ? 'Roles' : 'Role')}
            variant="outlined"
            InputProps={newInputProps}
            {...(size && { size })}
          />
        );
      }}
    />
  );
};
